import {API} from "./API";
import {Department} from "../models/Department";

export class DepartmentsAPI extends API<Department> {

	constructor () {
		super("departments");
    }
}
